import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownRight1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.95 8.428v8.522m0 0H8.549m8.4 0L7.05 7.05"
    />
  </svg>
);
export default SvgArrowDownRight1;
